// extracted by mini-css-extract-plugin
export default {"select_width":"cotractorTable_select_width__m3fQs"};